/**
 * Dashboard Constants
 */

// Re-export shared constant for backward compatibility
export { FILE_GENERATION_STATUS } from "../shared/constants";

/**
 * User role constants
 */
export const USER_ROLES = {
  READ_ONLY: "Read-only" as const,
  CONFIGURATOR: "Configurator" as const,
  ADMIN: "Admin" as const,
} as const;

/**
 * Configuration status constants
 */
export const CONFIGURATION_STATUS = {
  ACTIVE: "Active" as const,
  NOT_ACTIVE: "Not Active" as const,
} as const;

/**
 * Active status display constants (lowercase for search)
 */
export const ACTIVE_STATUS_DISPLAY = {
  ACTIVE: "active" as const,
  NOT_ACTIVE: "not active" as const,
} as const;

/**
 * Sort icon constants (Bootstrap Icons)
 */
export const SORT_ICONS = {
  UNSORTED: "bi-arrow-down-up" as const,
  ASC: "bi-arrow-up" as const,
  DESC: "bi-arrow-down" as const,
} as const;

/**
 * Sort direction constants
 */
export const SORT_DIRECTION = {
  ASC: "asc" as const,
  DESC: "desc" as const,
} as const;

/**
 * SFTP status constants
 */
export const SFTP_STATUS = {
  CONFIGURED: "Configured" as const,
  NOT_CONFIGURED: "Not Configured" as const,
} as const;

/**
 * Column name constants for sorting
 */
export const COLUMN = {
  COUNTY: "countyName" as const,
  DISTRICT: "districtName" as const,
  FISCAL_YEAR: "fiscalYear" as const,
  FISCAL701_TIME: "fiscal701Time" as const,
  FISCAL702_TIME: "fiscal702Time" as const,
  STATUS: "status" as const,
  IS_ACTIVE: "isActive" as const,
} as const;

/**
 * Badge CSS class constants
 */
export const BADGE_CLASSES = {
  SUCCESS: "bg-success" as const,
  WARNING: "bg-warning text-dark" as const,
  DANGER: "bg-danger" as const,
  SECONDARY: "bg-secondary" as const,
} as const;
